import React from 'react';
import { Scale } from 'lucide-react';
import ManagedInfoPageView from '../components/site/ManagedInfoPageView';
import { useManagedInfoPage } from '../hooks/useManagedInfoPage';

const LegalFallback: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
    <main className="flex-grow">
      <section className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 text-white py-16 md:py-20">
        <div className="container mx-auto px-4 text-center max-w-3xl mx-auto">
          <Scale className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Legal Information</h1>
          <p className="text-xl text-gray-300">Configure this page in Admin → Legal.</p>
        </div>
      </section>
    </main>
  </div>
);

const Legal: React.FC = () => {
  const { data, loading, error } = useManagedInfoPage('legal');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 pt-16 text-sm text-gray-500">
        Loading…
      </div>
    );
  }

  if (data && !error) {
    return <ManagedInfoPageView data={data} />;
  }

  return <LegalFallback />;
};

export default Legal;
